import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const PanelHeaderTool = (props) => {
    const { className, ...otherProps } = props;
    return <div {...otherProps} className={clsx("panel-header-tools", className)} />;
};
PanelHeaderTool.propTypes = {
    className: PropTypes.string,
};

export default PanelHeaderTool;
